import React, { useEffect, useRef } from 'react';
import $ from 'jquery';
import 'summernote/dist/summernote-lite.min.css';
import 'summernote/dist/summernote-lite.min.js';

const SummernoteEditorNewsLetters = ({ value, onChange }) => {
    const editorRef = useRef(null);

    useEffect(() => {
        if (typeof $ === 'undefined') {
            console.error('jQuery n\'est pas chargé');
            return;
        }

        if (editorRef.current) {
            $(editorRef.current).summernote({
                height: 300,
                dialogsInBody: true, // IMPORTANT: Les modales s'affichent dans le body
                disableDragAndDrop: false,
                inheritPlaceholder: true,
                toolbar: [
                    ['style', ['style']],
                    ['font', ['bold', 'italic', 'underline', 'clear']],
                    ['fontname', ['fontname']],
                    ['color', ['color']],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['table', ['table']],
                    ['insert', ['link', 'picture', 'video']],
                    ['view', ['codeview', 'help']]
                ],
                popover: {
                    image: [
                        ['imagesize', ['imageSize100', 'imageSize50', 'imageSize25']],
                        ['float', ['floatLeft', 'floatRight', 'floatNone']],
                        ['remove', ['removeMedia']]
                    ],
                    link: [
                        ['link', ['linkDialogShow', 'unlink']]
                    ],
                    table: [
                        ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
                        ['delete', ['deleteRow', 'deleteCol', 'deleteTable']]
                    ]
                },
                callbacks: {
                    onChange: function (contents) {
                        onChange(contents);
                    },
                    onPaste: function (e) {
                        const bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                        e.preventDefault();
                        document.execCommand('insertText', false, bufferText);
                    },
                    onImageUpload: function (files) {
                        // Gestion de l'upload d'image
                        const file = files[0];
                        const reader = new FileReader();
                        reader.onloadend = function () {
                            const image = $('<img>').attr('src', reader.result);
                            $(editorRef.current).summernote('insertNode', image[0]);
                        };
                        reader.readAsDataURL(file);
                    }
                }
            });

            // Définir le contenu initial
            $(editorRef.current).summernote('code', value);
        }

        // Correction pour les modales Bootstrap
        $(document).on("hidden.bs.modal", ".modal", function () {
            if ($(".modal:visible").length) {
                $("body").addClass("modal-open");
            }
        });

        return () => {
            if (editorRef.current && typeof $ !== 'undefined') {
                $(editorRef.current).summernote('destroy');
            }
            $(document).off("hidden.bs.modal"); // Nettoyage
        };
    }, []);

    useEffect(() => {
        if (editorRef.current && typeof $ !== 'undefined' && $(editorRef.current).summernote('code') !== value) {
            $(editorRef.current).summernote('code', value);
        }
    }, [value]);

    return (
        <div>
            <div ref={editorRef}></div>
        </div>
    );
};

export default SummernoteEditorNewsLetters;




// import React, { useEffect, useRef } from 'react';
// import $ from 'jquery';
// import 'summernote/dist/summernote-lite.min.css';
// import 'summernote/dist/summernote-lite.min.js';

// const SummernoteEditorNewsLetters = ({ value, onChange }) => {
//     const editorRef = useRef(null);

//     // Fonction pour uploader l'image vers le serveur
//     const uploadImageToServer = async (file) => {
//         const formData = new FormData();
//         formData.append('image', file);
        
//         try {
//             const response = await fetch(`${process.env.REACT_APP_HOTE}/upload-newsletter-image/`, {
//                 method: 'POST',
//                 body: formData,
//             });

//             if (response.ok) {
//                 const data = await response.json();
//                 console.log(data.image_url)
//                 return data.image_url; // URL de l'image sur le serveur
//             } else {
//                 console.error('Erreur lors de l\'upload de l\'image');
//                 return null;
//             }
//         } catch (error) {
//             console.error('Erreur réseau:', error);
//             return null;
//         }
//     };

//     useEffect(() => {
//         if (typeof $ === 'undefined') {
//             console.error('jQuery n\'est pas chargé');
//             return;
//         }

//         if (editorRef.current) {
//             $(editorRef.current).summernote({
//                 height: 300,
//                 dialogsInBody: true,
//                 disableDragAndDrop: false,
//                 inheritPlaceholder: true,
//                 toolbar: [
//                     ['style', ['style']],
//                     ['font', ['bold', 'italic', 'underline', 'clear']],
//                     ['fontname', ['fontname']],
//                     ['color', ['color']],
//                     ['para', ['ul', 'ol', 'paragraph']],
//                     ['table', ['table']],
//                     ['insert', ['link', 'picture', 'video']],
//                     ['view', ['codeview', 'help']]
//                 ],
//                 popover: {
//                     image: [
//                         ['imagesize', ['imageSize100', 'imageSize50', 'imageSize25']],
//                         ['float', ['floatLeft', 'floatRight', 'floatNone']],
//                         ['remove', ['removeMedia']]
//                     ],
//                     link: [
//                         ['link', ['linkDialogShow', 'unlink']]
//                     ],
//                     table: [
//                         ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
//                         ['delete', ['deleteRow', 'deleteCol', 'deleteTable']]
//                     ]
//                 },
//                 callbacks: {
//                     onChange: function (contents) {
//                         onChange(contents);
//                     },
//                     onPaste: function (e) {
//                         const bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
//                         e.preventDefault();
//                         document.execCommand('insertText', false, bufferText);
//                     },
//                     onImageUpload: async function (files) {
//                         for (let i = 0; i < files.length; i++) {
//                             const file = files[i];
                            
//                             // Vérifier la taille du fichier (max 2MB)
//                             if (file.size > 2 * 1024 * 1024) {
//                                 alert('L\'image ne doit pas dépasser 2MB');
//                                 continue;
//                             }

//                             // Vérifier le type de fichier
//                             if (!file.type.startsWith('image/')) {
//                                 alert('Veuillez sélectionner une image valide');
//                                 continue;
//                             }

//                             try {
//                                 // Afficher un indicateur de chargement
//                                 $(editorRef.current).summernote('insertText', ' [Upload de l\'image...] ');

//                                 const imageUrl = await uploadImageToServer(file);
//                                 console.log("hh", imageUrl)
                                
//                                 if (imageUrl) {
//                                     // CORRECTION : Utiliser insertNode au lieu de insertImage
//                                     $(editorRef.current).summernote('undo'); // Retirer le texte de chargement
                                    
//                                     // Méthode 1 : Créer un élément img et l'insérer
//                                     const img = document.createElement('img');
//                                     img.src = imageUrl;
//                                     img.style.maxWidth = '100%';
//                                     img.style.height = 'auto';
//                                     $(editorRef.current).summernote('insertNode', img);
                                    
//                                     // Méthode alternative 2 : Utiliser la syntaxe jQuery
//                                     // const $img = $('<img>').attr('src', imageUrl).css({
//                                     //     'max-width': '100%',
//                                     //     'height': 'auto'
//                                     // });
//                                     // $(editorRef.current).summernote('insertNode', $img[0]);
                                    
//                                 } else {
//                                     $(editorRef.current).summernote('undo');
//                                     alert('Erreur lors de l\'upload de l\'image');
//                                 }
//                             } catch (error) {
//                                 $(editorRef.current).summernote('undo');
//                                 console.error('Erreur:', error);
//                                 alert('Erreur lors du traitement de l\'image');
//                             }
//                         }
//                     }
//                 }
//             });

//             // Définir le contenu initial
//             $(editorRef.current).summernote('code', value);
//         }

//         // Correction pour les modales Bootstrap
//         $(document).on("hidden.bs.modal", ".modal", function () {
//             if ($(".modal:visible").length) {
//                 $("body").addClass("modal-open");
//             }
//         });

//         return () => {
//             if (editorRef.current && typeof $ !== 'undefined') {
//                 $(editorRef.current).summernote('destroy');
//             }
//             $(document).off("hidden.bs.modal");
//         };
//     }, []);

//     useEffect(() => {
//         if (editorRef.current && typeof $ !== 'undefined') {
//             const currentContent = $(editorRef.current).summernote('code');
//             if (currentContent !== value) {
//                 $(editorRef.current).summernote('code', value);
//             }
//         }
//     }, [value]);

//     return (
//         <div>
//             <div ref={editorRef}></div>
//         </div>
//     );
// };

// export default SummernoteEditorNewsLetters;